import React from 'react';

import { Trans, useTranslation } from 'react-i18next';

import styled from 'styled-components';

import Box from 'atoms/Box';
import InlineLink from 'atoms/InlineLink';
import Text from 'atoms/Text';

import { theme } from 'theme';

export interface PrivacyPolicyProps {}

function PrivacyPolicy({}: PrivacyPolicyProps) {
  const { t } = useTranslation();
  const row = window.location.origin.includes('3d4medical.com');

  return (
    <Wrapper align="center" mt={0.375} mb={2.25}>
      <Text lineHeight={1.35} align="left" size={1}>
        <Trans i18nKey="privacy.text">
          By clicking the button below you are accepting cookies in accordance
          with our
          <InlineLink
            href={
              row
                ? 'https://3d4medical.com/privacy-policy'
                : 'https://completeanatomy.cn/privacy-policy'
            }
            target="_blank"
          >
            privacy policy
          </InlineLink>
          .
        </Trans>
      </Text>
    </Wrapper>
  );
}

const Wrapper = styled(Box)`
  font-size: 0.88em;

  ${theme.devices.tablet`
    font-size: 0.5em;
    margin-bottom: 4.5em;
  `}
`;

export default PrivacyPolicy;
